import Dashboard from "../../components/Dashboard/Dashboard";
import {Assignment, EmojiEvents, Equalizer, Face, Mail, Message, People, Settings, ViewList} from "@material-ui/icons";
import React from "react";
import KidList from "../../components/KidList/KidList";
import TaskList from "../../components/TaskList/TaskList";
import KidPanel from "../../components/KidPanel/KidPanel";
import {Typography} from "@material-ui/core";



const AdultBoard = () => {
    const menu = [
        {title: 'Kids', icon: <Face/>, link: '/users'},
        {title: 'Tasks', icon: <Assignment/>, link: '/posts'},
        {title: 'Prizes', icon: <EmojiEvents/>, link: '/mailing'},
        {title: 'Send message', icon: <Message/>, link: '/sendmsg'},
        {title: 'Stats', icon: <Equalizer/>, link: '/mailing'},
        {title: 'Settings', icon: <Settings/>, link: '/settings'},
    ]

    return (
        <div>
            <Dashboard menu={menu}>
                <Typography variant={'h4'}>
                    Kids
                </Typography>
                <KidList/>
                <KidPanel/>
            </Dashboard>
        </div>
    );
};

export default AdultBoard;
